"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactBootstrap = require("react-bootstrap");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _QuestionsActions = require("../../../redux/Questions/QuestionsActions");

var _DropIndicator = _interopRequireDefault(require("./DropIndicator"));

require("../../../../css/QuestionFieldItem.css");

var _useDraggableListItem2 = _interopRequireDefault(require("./hooks/useDraggableListItem"));

var _logic = require("./logic");

var _useAnimateOnReorder = _interopRequireDefault(require("./hooks/useAnimateOnReorder"));

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var QuestionFieldItem = function QuestionFieldItem(_ref) {
  var item = _ref.item,
      index = _ref.index,
      useListContext = _ref.useListContext,
      onMoveQuestion = _ref.onMoveQuestion,
      disableMoveUp = _ref.disableMoveUp,
      disableMoveDown = _ref.disableMoveDown,
      lastReorderedQuestionId = _ref.lastReorderedQuestionId,
      setLastReorderedQuestionId = _ref.setLastReorderedQuestionId;

  var _useState = (0, _react.useState)(null),
      closestEdge = _useState[0],
      setClosestEdge = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      showButtons = _useState2[0],
      setShowButtons = _useState2[1];

  var _useState3 = (0, _react.useState)(_logic.idleState),
      draggableState = _useState3[0],
      setDraggableState = _useState3[1];

  var _useDraggableListItem = (0, _useDraggableListItem2["default"])(setDraggableState, setClosestEdge, useListContext, item, index),
      itemRef = _useDraggableListItem.itemRef,
      dragHandleRef = _useDraggableListItem.dragHandleRef;

  var moveUp = function moveUp() {
    return onMoveQuestion(item, index, index - 1, 0);
  };

  var moveDown = function moveDown() {
    return onMoveQuestion(item, index, index + 1, 0);
  };

  var reorderDisabled = disableMoveUp && disableMoveDown;
  (0, _useAnimateOnReorder["default"])(item, itemRef, lastReorderedQuestionId, setLastReorderedQuestionId);
  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Container, {
      "data-cy": "question-" + index,
      ref: itemRef,
      className: "list-item-container",
      style: {
        cursor: draggableState.type === 'dragging' ? 'grabbing' : 'grab'
      },
      onMouseEnter: function onMouseEnter() {
        return setShowButtons(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setShowButtons(false);
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "list-item " + (draggableState.type === 'dragging' ? 'list-item-disabled' : '')
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      type: "button",
      ref: dragHandleRef,
      "data-cy": "drag-handle-" + index,
      disabled: reorderDisabled,
      title: "Drag to reorder " + item.name,
      style: {
        visibility: 'visible',
        display: 'inline-block',
        border: 'none',
        cursor: draggableState.type === 'dragging' ? 'grabbing' : 'grab'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _proRegularSvgIcons.faBars
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "item-label"
    }, item.name),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.ButtonGroup, {
      className: "button-group",
      label: "Reorder " + item.name
    }, !disableMoveUp && showButtons &&
    /*#__PURE__*/
    _react["default"].createElement("button", {
      type: "button",
      onClick: function onClick() {
        return moveUp();
      },
      className: "item-button",
      "data-cy": index + "-move-up"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faArrowCircleUp
    })), !disableMoveDown && showButtons &&
    /*#__PURE__*/
    _react["default"].createElement("button", {
      type: "button",
      onClick: function onClick() {
        return moveDown();
      },
      className: "item-button",
      "data-cy": index + "-move-down"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faArrowCircleDown
    })))), closestEdge &&
    /*#__PURE__*/
    _react["default"].createElement(_DropIndicator["default"], {
      edge: closestEdge,
      gap: "1px"
    })), draggableState.type === 'preview' &&
    /*#__PURE__*/
    _reactDom["default"].createPortal(
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "list-item-preview"
    }, item.name), draggableState.container))
  );
};

QuestionFieldItem.defaultProps = {
  disableMoveUp: false,
  disableMoveDown: false,
  lastReorderedQuestionId: null
};
QuestionFieldItem.propTypes = process.env.NODE_ENV !== "production" ? {
  item: _propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    name: _propTypes["default"].string.isRequired,
    position: _propTypes["default"].number.isRequired
  }).isRequired,
  index: _propTypes["default"].number.isRequired,
  useListContext: _propTypes["default"].func.isRequired,
  onMoveQuestion: _propTypes["default"].func.isRequired,
  disableMoveUp: _propTypes["default"].bool,
  disableMoveDown: _propTypes["default"].bool,
  setLastReorderedQuestionId: _propTypes["default"].func.isRequired,
  lastReorderedQuestionId: _propTypes["default"].number
} : {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    lastReorderedQuestionId: state.questionSet.lastReorderedQuestionId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setLastReorderedQuestionId: function setLastReorderedQuestionId(questionId) {
      return dispatch((0, _QuestionsActions.updateLastReorderedQuestion)(questionId));
    }
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuestionFieldItem);